import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	emptyFieldText: {
		id: 'issue-empty-field-text.empty-field-text',
		defaultMessage: 'None',
		description: 'Text to indicate that a given issue field has no value set',
	},
	bespokenDateTimePlaceholderEmptyFieldText: {
		id: 'issue-empty-field-text.bespoken-date-time-placeholder-empty-field-text',
		defaultMessage: 'Add date',
		description: 'Text to indicate that date time field has no value set',
	},
	bespokenSingleGroupPickerPlaceholderEmptyFieldText: {
		id: 'issue-empty-field-text.bespoken-single-group-placeholder-empty-field-text',
		defaultMessage: 'Add group',
		description: 'Text to indicate that a single group picker field has no value set',
	},
	bespokenMultiGroupPickerPlaceholderEmptyFieldText: {
		id: 'issue-empty-field-text.bespoken-multi-group-placeholder-empty-field-text',
		defaultMessage: 'Add groups',
		description: 'Text to indicate that a multi group picker field has no value set',
	},
	bespokenCascadingSelectPlaceholderEmptyFieldText: {
		id: 'issue-empty-field-text.bespoken-cascading-select-placeholder-empty-field-text',
		defaultMessage: 'Add option',
		description: 'Text to indicate that cascading select field has no value set',
	},
});

export type Message = {
	id: string;
	defaultMessage: string;
	description: string;
};
